export const getUrlParams = (): { [key: string]: string } => {
  const urlParams = new URLSearchParams(window.location.search);
  const params: { [key: string]: string } = {};

  urlParams.forEach((value, key) => {
    params[key] = value;
  });

  return params;
};

export const removeUrlParam = (param: string) => {
  const url = new URL(window.location.href);
  url.searchParams.delete(param);
  window.history.replaceState({}, '', url.toString());
};
